// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-bar[data-v-2e1bc946] {\n  max-width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
